export default "__VITE_ASSET___3B3Wh8D__"